import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import { getStripePublishableKey } from '@client/util/stripeConfig';

const stripePromise = loadStripe(getStripePublishableKey());

interface StripeEmbeddedCheckoutProps {
  clientSecret: string;
}

export function StripeEmbeddedCheckout({ clientSecret }: StripeEmbeddedCheckoutProps) {
  return (
    <div id="checkout" className="w-full">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={{ clientSecret }}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}
